<template>
  <div class="query-list-cell" @click="onClick">
    <div class="query-list-cell-content" :class="{ 'bottom-line': !isLast }">
      <div class="query-list-cell-content-left">
        <p class="query-list-cell-content-left-title">{{ model.title }}</p>
        <p class="query-list-cell-content-left-info">{{ model.info }}</p>
      </div>
      <div class="query-list-cell-content-right">
        <p
          class="query-list-cell-content-right-status"
          :class="[isFilled ? 'red' : 'gray']"
        >
          {{ isFilled ? "已填" : "未填" }}
        </p>
        <img
          class="query-list-cell-content-right-arrow"
          src="@img/arrow-right.png"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    model: Object,
    isLast: Boolean
  },

  computed: {
    isFilled () {
      return this.model.isFilled
    }
  },

  methods: {
    onClick () {
      this.$emit('onClick')
    }
  }
}
</script>

<style lang="scss" scoped>
@use "@css/style.scss";
.query-list-cell {
  background-color: white;
  width: 100%;
  height: 70px;
  box-sizing: border-box;
  padding-left: 16px;
  padding-right: 16px;

  &-content {
    width: 100%;
    height: 69px;
    display: flex;
    justify-content: space-between;

    &-left {
      height: 100%;
      display: flex;
      flex-direction: column;

      &-title {
        color: #323233;
        font-size: 14px;
        line-height: 20px;
        margin-top: 12px;
      }

      &-info {
        color: #969799;
        font-size: 12px;
        line-height: 16px;
        margin-top: 8px;
      }
    }

    &-right {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      &-arrow {
        width: 18px;
        height: 18px;
      }

      &-status {
        font-size: 14px;
        margin-right: 4px;
      }
    }
  }
}

.bottom-line {
  border-bottom: solid 1px #ebedf0;
}

.red {
  color: #596afd;
}

.gray {
  color: #969799;
}
</style>
